// extracted by mini-css-extract-plugin
export var container = "_cv-0";
export var icon = "_cv-1";
export var text = "_cv-2";